import React from 'react';
import PropTypes from 'prop-types';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Hidden from '@material-ui/core/Hidden';
import Grid from '@material-ui/core/Grid';
import ReplaceContact from '../../components/Replace/ReplaceContact/ReplaceContact';
import DownloadLink from '../../components/DownloadLink/DownloadLink';
import Logo from './logo.png';
import LetterHead from './letterhead.png';

import {
  getString,
  stringToCurrency,
  stringToDateShortLeadingZero,
} from '../../helpers/stringHelpers.js';
import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

const stringsComponent = 'transactionsTable';

class TransactionsTable extends React.Component {
  constructor(props) {
    super(props);
  }

  download(
    transactions,
    today,
    monthsAgo,
    customerName,
    address,
    paymentReference,
    openingBalance,
    currentBalance,
    accountType
  ) {
    const { tenantStatus, tenantStart, tenantEnd, gaEvent } = this.props;
    gaEvent();

    const accountTypeFormatted =
      accountType.charAt(0).toUpperCase() + accountType.slice(1);
    let transactionsArray = [
      [
        { text: 'DATE', style: 'tableHeader' },
        { text: 'DESCRIPTION', style: 'tableHeader' },
        { text: 'MONEY IN', style: 'tableHeader', alignment: 'right' },
        { text: 'MONEY OUT', style: 'tableHeader', alignment: 'right' },
        { text: 'BALANCE', style: 'tableHeader', alignment: 'right' },
      ],
    ];

    transactionsArray.push([
      { text: stringToDateShortLeadingZero(today) },
      'CURRENT BALANCE',
      '',
      '',
      {
        text: stringToCurrency(currentBalance),
        alignment: 'right',
        color: currentBalance && currentBalance > 0 ? '#438509' : 'black',
      },
    ]);

    if (transactions.length) {
      transactions.forEach((t) => {
        transactionsArray.push([
          t.transactionDate
            ? stringToDateShortLeadingZero(t.transactionDate)
            : '',
          t.transactionDescription ? t.transactionDescription : '',
          [
            {
              text: t.credit ? stringToCurrency(t.credit) : '',
              alignment: 'right',
            },
          ],
          [
            {
              text: t.debit ? stringToCurrency(t.debit) : '',
              alignment: 'right',
            },
          ],
          [
            {
              text: t.balance ? stringToCurrency(t.balance) : '',
              alignment: 'right',
            },
          ],
        ]);
      });
    }

    transactionsArray.push([
      { text: stringToDateShortLeadingZero(monthsAgo) },
      'OPENING BALANCE',
      '',
      '',
      {
        text: stringToCurrency(openingBalance),
        alignment: 'right',
        color: openingBalance && openingBalance > 0 ? '#438509' : 'black',
      },
    ]);

    var docDefinition = {
      content: [
        {
          layout: 'noBorders',
          table: {
            widths: ['60%', '*'],
            body: [
              [
                { image: Logo, width: 180 },
                { image: LetterHead, width: 200 },
              ],
            ],
          },
        },
        {
          text: stringToDateShortLeadingZero(today.toISOString()),
          style: 'date',
        },
        { text: customerName, style: 'name' },
        { text: address, style: 'name' },
        {
          text:
            `Tenancy Status: ${tenantStatus}
             Tenancy Start Date: ${stringToDateShortLeadingZero(tenantStart)}` +
            `${
              tenantEnd
                ? `\nTenancy End Date: ${stringToDateShortLeadingZero(
                    tenantEnd
                  )}`
                : ''
            }`,
          style: 'tenancyDetails',
        },
        {
          text: `${accountTypeFormatted} Statement from ${stringToDateShortLeadingZero(
            monthsAgo.toISOString()
          )} to ${stringToDateShortLeadingZero(today.toISOString())}`,
          style: 'statementDate',
        },
        {
          text: `Payment Reference: ${paymentReference}`,
          style: 'paymentReference',
        },
        {
          table: {
            headerRows: 1,
            widths: [65, '*', 55, 65, 55],
            body: transactionsArray,
          },
          layout: {
            hLineWidth: function (i, node) {
              let hLineWidth = 1;
              if (i === 0) {
                hLineWidth = 0;
              }
              return hLineWidth;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return i === 1 ||
                i === 2 ||
                i === node.table.body.length ||
                i === node.table.body.length - 1
                ? '#333333'
                : '#E1E1E1';
            },
            paddingTop: function (i, node) {
              return 4;
            },
            paddingBottom: function (i, node) {
              return 4;
            },
          },
        },
      ],
      styles: {
        date: {
          fontSize: 13,
          bold: true,
          margin: [0, 16, 0, 16],
        },
        name: {
          fontSize: 13,
        },
        statementDate: {
          margin: [0, 16, 0, 16],
          fontSize: 13,
          bold: true,
        },
        tableHeader: {
          bold: true,
          fontSize: 10,
          color: 'black',
        },
        tenancyDetails: {
          fontSize: 13,
          margin: [0, 16, 0, 0],
        },
        paymentReference: {
          fontSize: 13,
          margin: [0, 0, 0, 16],
        },
        footerText: {
          fontSize: 10,
        },
      },
      defaultStyle: {
        fontSize: 10,
      },
      footer: function (currentPage, pageCount) {
        return [
          {
            columns: [
              {
                text: `${accountTypeFormatted} Statement`,
                alignment: 'left',
                margin: [40, 10, 0, 0],
                style: 'footerText',
              },
              {
                text: 'Page ' + currentPage.toString() + ' of ' + pageCount,
                alignment: 'right',
                margin: [0, 10, 40, 0],
                style: 'footerText',
              },
            ],
          },
        ];
      },
    };

    import(/* webpackChunkName: "pdffonts" */ 'pdfmake/build/vfs_fonts').then(
      (pdfFonts) => {
        import(/* webpackChunkName: "pdfmake" */ 'pdfmake/build/pdfmake').then(
          () => {
            pdfMake.vfs = pdfFonts.pdfMake.vfs;
            var pdf = pdfMake.createPdf(docDefinition);
            pdf.download(
              `MyKāingaOra ${accountTypeFormatted} Statement ${stringToDateShortLeadingZero(
                monthsAgo.toISOString()
              )}-${stringToDateShortLeadingZero(today.toISOString())}.pdf`
            );
          }
        );
      }
    );
  }

  render() {
    const {
      classes,
      transactions,
      currentBalance,
      openingBalance,
      customerName,
      address,
      paymentReference,
      accountType,
      toggleContactModal,
    } = this.props;

    let id = 0;
    const today = moment();
    const monthsAgo = moment().subtract(
      portalContent.APP_MONTHS_TRANSACTIONS,
      'months'
    );
    const transactionsLastIndex = transactions.length - 1;

    return (
      <div className={classes.root}>
        <Grid container spacing={0}>
          <Grid item xs={12} md={8}>
            <Typography className={classes.dateRange}>
              {stringToDateShortLeadingZero(monthsAgo.toISOString())} to{' '}
              {stringToDateShortLeadingZero(today.toISOString())}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4} className={classes.downloadContainer}>
            <Typography component="span" variant="body2">
              <DownloadLink
                label={`${getString(stringsComponent, 'DOWNLOAD_LABEL')} [PDF]`}
                action={() => {
                  this.download(
                    transactions,
                    today,
                    monthsAgo,
                    customerName,
                    address,
                    paymentReference,
                    openingBalance,
                    currentBalance,
                    accountType
                  );
                }}
              />
            </Typography>
          </Grid>
        </Grid>
        <Hidden xsDown>
          <Card className={`Card ${classes.tableCard}`}>
            <CardContent className={classes.tableCardContent}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableCellHead}>
                      Date
                    </TableCell>
                    <TableCell className={classes.tableCellHead}>
                      Description
                    </TableCell>
                    <TableCell align="right" className={classes.tableCellHead}>
                      Money In
                    </TableCell>
                    <TableCell align="right" className={classes.tableCellHead}>
                      Money Out
                    </TableCell>
                    <TableCell align="right" className={classes.tableCellHead}>
                      Balance
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className={classes.transactionsTableBody}>
                  <TableRow key={id++}>
                    <TableCell className={classes.tableCell}>
                      {stringToDateShortLeadingZero(today.toISOString())}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      CURRENT BALANCE
                    </TableCell>
                    <TableCell align="right" className={classes.credit} />
                    <TableCell align="right" className={classes.tableCell} />
                    <TableCell align="right" className={classes.tableCell}>
                      {currentBalance > 0 ? (
                        <span className={classes.credit}>
                          {stringToCurrency(currentBalance)}
                        </span>
                      ) : (
                        stringToCurrency(currentBalance)
                      )}
                    </TableCell>
                  </TableRow>
                  {transactions.map((t) => {
                    return (
                      <TableRow key={id++}>
                        <TableCell className={classes.tableCell}>
                          {stringToDateShortLeadingZero(t.transactionDate)}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {t.transactionDescription}
                        </TableCell>
                        <TableCell align="right" className={classes.credit}>
                          {t.credit ? stringToCurrency(t.credit) : ''}
                        </TableCell>
                        <TableCell align="right" className={classes.tableCell}>
                          {t.debit ? stringToCurrency(t.debit) : ''}
                        </TableCell>
                        <TableCell align="right" className={classes.tableCell}>
                          {t.balance > 0 ? (
                            <span className={classes.credit}>
                              {stringToCurrency(t.balance)}
                            </span>
                          ) : (
                            stringToCurrency(t.balance)
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  <TableRow key={id++}>
                    <TableCell className={classes.tableCell}>
                      {stringToDateShortLeadingZero(monthsAgo.toISOString())}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      OPENING BALANCE
                    </TableCell>
                    <TableCell align="right" className={classes.credit} />
                    <TableCell align="right" className={classes.tableCell} />
                    <TableCell align="right" className={classes.tableCell}>
                      {openingBalance > 0 ? (
                        <span className={classes.credit}>
                          {stringToCurrency(openingBalance)}
                        </span>
                      ) : (
                        stringToCurrency(openingBalance)
                      )}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              <Typography
                className={classes.helpText}
                component="p"
                variant="body1"
              >
                {getString(stringsComponent, 'HELP_TEXT').replace(
                  '{months}',
                  portalContent.APP_MONTHS_TRANSACTIONS
                )}
                <br />
                <ReplaceContact
                  content={getString(stringsComponent, 'HELP_TEXT_2')}
                  action={toggleContactModal}
                  isLink={true}
                />
              </Typography>
            </CardContent>
          </Card>
        </Hidden>
        <Hidden smUp>
          <Grid
            container
            spacing={0}
            key={id++}
            className={classes.currentBalance}
          >
            <Grid item xs={8} sm={10} className={classes.gridItem}>
              <Typography
                className={`${classes.description} ${classes.currentBalanceLabel}`}
              >
                CURRENT BALANCE
              </Typography>
              <Typography className={classes.date}>
                {stringToDateShortLeadingZero(today.toISOString())}
              </Typography>
            </Grid>
            <Grid item xs={4} sm={2} className={classes.gridItem}>
              <Typography className={classes.amount}>
                {currentBalance > 0 ? (
                  <span className={classes.credit}>
                    {stringToCurrency(currentBalance)}
                  </span>
                ) : (
                  stringToCurrency(currentBalance)
                )}
              </Typography>
            </Grid>
          </Grid>
          {transactions.map((t, i) => {
            const rentDebitDescription = 'Rent Charged';
            const transactionDescriptionFull = t.transactionDescription;
            const transactionDescription =
              transactionDescriptionFull.startsWith(rentDebitDescription)
                ? rentDebitDescription
                : null;
            const transactionDescriptionDate = transactionDescription
              ? transactionDescriptionFull
                  .slice(
                    transactionDescriptionFull.indexOf(rentDebitDescription) +
                      rentDebitDescription.length
                  )
                  .trim()
              : null;

            return (
              <Grid
                container
                spacing={0}
                key={id++}
                className={
                  i == transactionsLastIndex
                    ? classes.gridRowLast
                    : classes.gridRow
                }
              >
                <Grid item xs={7} sm={10} className={classes.gridItem}>
                  <Typography className={classes.description}>
                    <Hidden xsDown>{transactionDescriptionFull}</Hidden>
                    <Hidden smUp>
                      {transactionDescription && transactionDescriptionDate ? (
                        <span>
                          {transactionDescription}
                          <br />
                          {transactionDescriptionDate}
                        </span>
                      ) : (
                        transactionDescriptionFull
                      )}
                    </Hidden>
                  </Typography>
                  <Typography className={classes.date}>
                    {stringToDateShortLeadingZero(t.transactionDate)}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={5}
                  sm={2}
                  className={classes.gridItem}
                  container
                  alignContent="space-between"
                >
                  <Grid item className={classes.nestedGridItem}>
                    <Typography className={classes.amount}>
                      {t.credit ? (
                        <span className={classes.credit}>
                          {stringToCurrency(t.credit)}
                        </span>
                      ) : (
                        ''
                      )}
                      {t.debit ? stringToCurrency(t.debit) : ''}
                    </Typography>
                  </Grid>
                  <Grid item className={classes.nestedGridItem}>
                    <Typography className={classes.runningBalanceMobile}>
                      Bal |{' '}
                      {t.balance > 0
                        ? stringToCurrency(t.balance)
                        : stringToCurrency(t.balance)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            );
          })}
          <Grid
            container
            spacing={0}
            key={id++}
            className={classes.currentBalance}
          >
            <Grid item xs={8} sm={10} className={classes.gridItem}>
              <Typography
                className={`${classes.description} ${classes.currentBalanceLabel}`}
              >
                OPENING BALANCE
              </Typography>
              <Typography className={classes.date}>
                {stringToDateShortLeadingZero(monthsAgo.toISOString())}
              </Typography>
            </Grid>
            <Grid item xs={4} sm={2} className={classes.gridItem}>
              <Typography className={classes.amount}>
                {openingBalance > 0 ? (
                  <span className={classes.credit}>
                    {stringToCurrency(openingBalance)}
                  </span>
                ) : (
                  stringToCurrency(openingBalance)
                )}
              </Typography>
            </Grid>
          </Grid>
          <Typography
            className={classes.helpText}
            component="p"
            variant="body1"
          >
            {getString(stringsComponent, 'HELP_TEXT').replace(
              '{months}',
              portalContent.APP_MONTHS_TRANSACTIONS
            )}
            <br />
            <ReplaceContact
              content={getString(stringsComponent, 'HELP_TEXT_2')}
              action={toggleContactModal}
              isLink={true}
            />
          </Typography>
        </Hidden>
      </div>
    );
  }
}

TransactionsTable.propTypes = {
  classes: PropTypes.object.isRequired,
  transactions: PropTypes.array,
  currentBalance: PropTypes.number.isRequired,
  openingBalance: PropTypes.number.isRequired,
  customerName: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  paymentReference: PropTypes.string.isRequired,
  accountType: PropTypes.string.isRequired,
  toggleContactModal: PropTypes.func.isRequired,
  tenantStatus: PropTypes.string.isRequired,
  tenantStart: PropTypes.string.isRequired,
  tenantEnd: PropTypes.string,
  gaEvent: PropTypes.func,
};

TransactionsTable.defaultProps = {
  transactions: [],
  tenantEnd: null,
};

export default withStyles(styles)(TransactionsTable);
